import { FC, useState } from 'react';
import Container from '@mui/material/Container';
import { Box, Collapse, Paper, useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';
import UtmsButton from '@shared/components/ui/UtmsButton';
import { ExpandLess, ExpandMore, Refresh } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface ErrorPageProps {
    errorTitle: string;
    errorMessage: string;
    errorDetails: string;
}

const ErrorPage: FC<ErrorPageProps> = ({ errorTitle, errorMessage, errorDetails }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const [showDetails, setShowDetails] = useState(false);

    const handleReloadApp = () => {
        window.location.reload();
    };

    const handleOpenDetails = () => {
        setShowDetails((prev) => !prev);
    };

    return (
        <Container maxWidth="sm" sx={{ mt: 10 }}>
            <Paper
                elevation={2}
                sx={{
                    p: 4,
                    borderRadius: 4,
                    textAlign: 'center',
                    bgcolor: theme.palette.background.paper,
                    color: theme.palette.text.primary,
                }}
            >
                <Typography fontWeight={700} variant="h4" gutterBottom color="error">
                    {errorTitle || t('error')}
                </Typography>
                <Typography variant="body1" gutterBottom>
                    {errorMessage}
                </Typography>
                {errorDetails && (
                    <>
                        <Box sx={{ mt: 2 }}>
                            <UtmsButton
                                onClick={handleOpenDetails}
                                endIcon={showDetails ? <ExpandLess /> : <ExpandMore />}
                                color="primary"
                            >
                                {showDetails ? 'Скрыть подробности' : 'Показать подробности'}
                            </UtmsButton>
                            <Collapse in={showDetails}>
                                <Box
                                    sx={{
                                        mt: 2,
                                        p: 2,
                                        bgcolor: theme.palette.mode === 'dark' ? '#1e1e1e' : '#f9f9f9',
                                        color: theme.palette.text.primary,
                                        border: `1px solid ${theme.palette.divider}`,
                                        borderRadius: 2,
                                        textAlign: 'left',
                                        fontFamily: 'monospace',
                                        fontSize: '0.9rem',
                                        whiteSpace: 'pre-wrap',
                                        maxHeight: 300,
                                        overflowY: 'auto',
                                    }}
                                >
                                    {errorDetails}
                                </Box>
                            </Collapse>
                        </Box>
                    </>
                )}
                <UtmsButton color="primary" sx={{ mt: 4 }} onClick={handleReloadApp} startIcon={<Refresh />}>
                    {t('reload_page')}
                </UtmsButton>
            </Paper>
        </Container>
    );
};

export default ErrorPage;
